import { ReportType } from './report-types';

export interface ReportExportPermissions {
  excel: boolean; // true si el usuario puede exportar a Excel
  pdf: boolean; // true si el usuario puede exportar a PDF
  html: boolean; // true si el usuario puede exportar a HTML
}
export interface ReportExportAccessKeys {
  excel: string; // true si el usuario puede exportar a Excel
  pdf: string; // true si el usuario puede exportar a PDF
  html: string; // true si el usuario puede exportar a HTML
}
export const reportExportPermissions: Partial<
  Record<ReportType, ReportExportAccessKeys>
> = {
  [ReportType.REPORTE_EXCESOS_VELOCIDAD_DIRECCION_NIVEL]: {
    excel: 'reports_excel_R055',
    pdf: 'reports_pdf_R055',
    html: 'reports_html_R055',
  },
  [ReportType.REPORTE_CONDUCTORES_ENROLADOS]: {
    excel: 'reports_excel_ R054',
    pdf: 'reports_pdf_R054',
    html: 'reports_html_R054',
  },
  [ReportType.REPORTE_PARADAS_MOVIMIENTOS]: {
    excel: 'reports_excel_R001',
    pdf: 'reports_pdf_R001',
    html: 'reports_html_R001',
  },
  [ReportType.REPORTE_CHECKLIST]: {
    excel: 'reports_excel_R053',
    pdf: 'un',
    html: 'un',
  },
  [ReportType.REPORTE_RELENTI]: {
    excel: 'reports_excel_R026',
    pdf: 'reports_pdf_R026',
    html: 'reports_html_R026',
  },
  [ReportType.REPORTE_RECORRIDO]: {
    excel: 'reports_excel_R050',
    pdf: 'reports_pdf_R050',
    html: 'reports_html_R050',
  },
  [ReportType.REPORTE_OPERATIVIDAD_EQUIPO]: {
    excel: 'reports_excel_R051',
    pdf: 'reports_pdf_R051',
    html: 'reports_html_R051',
  },
  [ReportType.REPORTE_EXCESOS_VELOCIDAD_LIMITE_PERSONALIZADO]: {
    excel: 'reports_excel_R002',
    pdf: 'reports_pdf_R002',
    html: 'reports_html_R002',
  },
  [ReportType.REPORTE_ENTRADA_SALIDA_GEOCERCAS]: {
    excel: 'reports_excel_R003',
    pdf: 'reports_pdf_R003',
    html: 'reports_html_R003',
  },
  [ReportType.REPORTE_COMBUSTIBLE_GENERAL]: {
    excel: 'reports_excel_R004',
    pdf: 'reports_pdf_R004',
    html: 'reports_html_R004',
  },
  [ReportType.REPORTE_COMBUSTIBLE_RESUMEN]: {
    excel: 'reports_excel_R042',
    pdf: 'reports_pdf_R042',
    html: 'reports_html_R042',
  },
  [ReportType.REPORTE_GENERAL]: {
    excel: 'reports_excel_R006',
    pdf: 'reports_pdf_R006',
    html: 'reports_html_R006',
  },
  [ReportType.REPORTE_POSICION]: {
    excel: 'reports_excel_R008',
    pdf: 'reports_pdf_R008',
    html: 'reports_html_R008',
  },
  [ReportType.REPORTE_EVENTOS]: {
    excel: 'reports_excel_R037',
    pdf: 'reports_pdf_R037',
    html: 'reports_html_R037',
  },
  [ReportType.REPORTE_ATENCION_EVENTOS]: {
    excel: 'reports_excel_R038',
    pdf: 'reports_pdf_R038',
    html: 'reports_html_R038',
  },
  [ReportType.REPORTE_COORDENADAS_GEOCERCAS]: {
    excel: 'reports_excel_R033',
    pdf: 'reports_pdf_R033',
    html: 'reports_html_R033',
  },
  [ReportType.REPORTE_COORDENADAS_GEOPUNTOS]: {
    excel: 'reports_excel_R034',
    pdf: 'reports_pdf_R034',
    html: 'reports_html_R034',
  },
  [ReportType.REPORTE_COORDENADAS_GEOCERCAS_CIRCULARES]: {
    excel: 'reports_excel_R035',
    pdf: 'reports_pdf_R035',
    html: 'reports_html_R035',
  },
  [ReportType.REPORTE_EVENTOS_INTERNO]: {
    excel: 'reports_excel_R040',
    pdf: 'reports_pdf_R040',
    html: 'reports_html_R040',
  },
  [ReportType.REPORTE_EXCESOS_VELOCIDAD_DURACION_TOLERANCIA_NIVEL_RIESGO]: {
    excel: 'reports_excel_R041',
    pdf: 'reports_pdf_R041',
    html: 'reports_html_R041',
  },
  [ReportType.REPORTE_ESTADO_TRANSMISION]: {
    excel: 'reports_excel_R043',
    pdf: 'reports_pdf_R043',
    html: 'reports_html_R043',
  },
  [ReportType.REPORTE_ESTADO_TRANSMISION_EVENTOS]: {
    excel: 'reports_excel_R046',
    pdf: 'reports_pdf_R046',
    html: 'reports_html_R046',
  },
  [ReportType.REPORTE_BOLIVIA]: {
    excel: 'reports_excel_R045',
    pdf: 'reports_pdf_R045',
    html: 'reports_html_R045',
  },
  [ReportType.REPORTE_EXCESOS_VELOCIDAD_POR_NIVEL]: {
    excel: 'reports_excel_R047',
    pdf: 'reports_pdf_R047',
    html: 'reports_html_R047',
  },
  [ReportType.REPORTE_RESUMEN_POR_DIA_NUEVO]: {
    excel: 'reports_excel_R048',
    pdf: 'reports_pdf_R048',
    html: 'reports_html_R048',
  },
  [ReportType.REPORTE_EXCESOS_VELOCIDAD_DIRECCION_DURACION_TOLERANCIA_NIVEL_RIESGO]:
    {
      excel: 'reports_excel_R044',
      pdf: 'reports_pdf_R044',
      html: 'reports_html_R044',
    },
  [ReportType.REPORTE_MONITOREO_CANTIDAD_EVENTOS_POR_UNIDAD]: {
    excel: 'reports_excel_R049',
    pdf: 'reports_pdf_R049',
    html: 'reports_html_R049',
  },
  [ReportType.REPORTE_EVENTOS_FORMATO_PAXI]: {
    excel: 'reports_excel_R056',
    pdf: 'reports_pdf_R056',
    html: 'reports_html_R056',
  },
  [ReportType.REPORTE_PARADAS_MOVIMIENTOS_NUEVO]: {
    excel: 'reports_excel_R057',
    pdf: 'reports_pdf_R057',
    html: 'reports_html_R057',
  },
  [ReportType.REPORTE_PRIMER_MOVIMIENTO]: {
    excel: 'reports_excel_R058',
    pdf: 'reports_pdf_R058',
    html: 'reports_html_R058',
  },
  [ReportType.REPORTE_PARADAS_MOVIMIENTOS_ENHANCED]: {
    excel: 'reports_excel_R059',
    pdf: 'reports_pdf_R059',
    html: 'reports_html_R059',
  },
};

export const reportFileNames: Record<ReportType | string, string> = {
  [ReportType.REPORTE_CONDUCTORES_ENROLADOS]: 'reporteConductoresEnrolados',
  [ReportType.REPORTE_PARADAS_MOVIMIENTOS]: 'reporteParadasMovimientos',
  [ReportType.REPORTE_RELENTI]: 'reporteRalenti',
  [ReportType.REPORTE_EXCESOS_VELOCIDAD_LIMITE_PERSONALIZADO]:
    'reporteExcesosVelocidadLimitePersonalizado',
  [ReportType.REPORTE_ENTRADA_SALIDA_GEOCERCAS]:
    'reporteEntradaSalidaGeocercas',
  [ReportType.REPORTE_COMBUSTIBLE_GENERAL]: 'reporteCombustibleGeneral',
  [ReportType.REPORTE_COMBUSTIBLE_RESUMEN]: 'reporteCombustibleResumen',
  [ReportType.REPORTE_GENERAL]: 'reporteGeneral',
  [ReportType.REPORTE_POSICION]: 'reportePosicion',
  [ReportType.REPORTE_RECORRIDO]: 'reporteRecorrido',
  [ReportType.REPORTE_EVENTOS]: 'reporteEventos',
  [ReportType.REPORTE_ATENCION_EVENTOS]: 'reporteAtencionEventos',
  [ReportType.REPORTE_COORDENADAS_GEOCERCAS]: 'reporteCoordenadasGeocercas',
  [ReportType.REPORTE_COORDENADAS_GEOPUNTOS]: 'reporteCoordenadasGeopuntos',
  [ReportType.REPORTE_COORDENADAS_GEOCERCAS_CIRCULARES]:
    'reporteCoordenadasGeocercasCirculares',
  [ReportType.REPORTE_EVENTOS_INTERNO]: 'reporteEventosInterno',
  [ReportType.REPORTE_EXCESOS_VELOCIDAD_DURACION_TOLERANCIA_NIVEL_RIESGO]:
    'reporteExcesosVelocidadDuracionToleranciaNivelRiesgo',
  [ReportType.REPORTE_EXCESOS_VELOCIDAD_DIRECCION_DURACION_TOLERANCIA_NIVEL_RIESGO]:
    'reporteExcesosVelocidadDireccionDuracionToleranciaNivelRiesgo',
  [ReportType.REPORTE_ESTADO_TRANSMISION]: 'reporteEstadoTransmision',
  [ReportType.REPORTE_ESTADO_TRANSMISION_EVENTOS]:
    'reporteEstadoTransmisionEventos',
  [ReportType.REPORTE_BOLIVIA]: 'reporteBolivia',
  [ReportType.REPORTE_EXCESOS_VELOCIDAD_POR_NIVEL]:
    'reporteExcesosVelocidadPorNivel',
  [ReportType.REPORTE_RESUMEN_POR_DIA_NUEVO]: 'reporteResumenPorDiaNuevo',
  [ReportType.REPORTE_MONITOREO_CANTIDAD_EVENTOS_POR_UNIDAD]:
    'reporteMonitoreoCantidadEventosPorUnidad',
  [ReportType.REPORTE_CHECKLIST]: 'reporteChecklist',
  [ReportType.REPORTE_OPERATIVIDAD_EQUIPO]: 'reporteOperatividadEquipo',
  [ReportType.REPORTE_ACTIVITY_WATCH_LOCAL]: 'reporteActivityWatchLocal',
  [ReportType.REPORTE_EXCESOS_VELOCIDAD_DIRECCION_NIVEL]:
    'reporteExcesosVelocidadDireccionNivel',
  [ReportType.REPORTE_EVENTOS_FORMATO_PAXI]:
    'reporteExcesosVelocidadNivelDuracion',
  [ReportType.REPORTE_PARADAS_MOVIMIENTOS_NUEVO]:
    'reporteParadasMovimientosNuevo',
  [ReportType.REPORTE_PRIMER_MOVIMIENTO]: 'reportePrimerMovimiento',
  [ReportType.REPORTE_PARADAS_MOVIMIENTOS_ENHANCED]:
    'reporteParadasMovimientosEnhanced',
  [ReportType.UNDEFINED]: 'undefined',
};
